<template>
  <span>{{ formattedDate }}</span>
</template>

<script>
import { parseSiteDateTimeFormat } from "@/time";

export default {
  name: "CmsDate",
  props: {
    date: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return this.date && parseSiteDateTimeFormat(this.date);
    },
  },
};
</script>
